import * as React from "react"

export default function InstagramIcon(props) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1316_30807)">
        <g clipPath="url(#clip1_1316_30807)" fill={props.fill}>
          <path d="M10 1.8c2.672 0 2.988.012 4.04.06.976.042 1.503.206 1.855.343.464.18.8.399 1.148.746.352.352.566.684.746 1.149.137.351.3.882.344 1.855.047 1.055.058 1.371.058 4.04 0 2.671-.011 2.987-.058 4.038-.043.977-.207 1.504-.344 1.856-.18.465-.398.8-.746 1.148a3.077 3.077 0 01-1.148.746c-.352.137-.883.301-1.856.344-1.055.047-1.371.059-4.039.059-2.672 0-2.988-.012-4.04-.059-.976-.043-1.503-.207-1.855-.344-.464-.18-.8-.398-1.148-.746a3.076 3.076 0 01-.746-1.148c-.137-.352-.3-.883-.344-1.856-.047-1.054-.058-1.37-.058-4.039 0-2.672.011-2.988.058-4.039.043-.976.207-1.504.344-1.855.18-.465.398-.801.746-1.149a3.076 3.076 0 011.148-.746c.352-.137.883-.3 1.856-.344 1.05-.046 1.367-.058 4.039-.058zM10 0C7.285 0 6.945.012 5.879.059 4.816.105 4.086.277 3.453.523A4.88 4.88 0 001.68 1.68 4.9 4.9 0 00.523 3.45C.277 4.085.105 4.811.06 5.874.012 6.945 0 7.285 0 10s.012 3.055.059 4.121c.046 1.063.218 1.793.464 2.426.258.66.598 1.219 1.157 1.773a4.888 4.888 0 001.77 1.153c.636.246 1.362.418 2.425.465 1.066.046 1.406.058 4.121.058 2.715 0 3.055-.012 4.121-.058 1.063-.047 1.793-.22 2.426-.465a4.888 4.888 0 001.77-1.153 4.888 4.888 0 001.152-1.77c.246-.636.418-1.363.465-2.425.047-1.066.058-1.406.058-4.121 0-2.715-.011-3.055-.058-4.121-.047-1.063-.22-1.793-.465-2.426A4.683 4.683 0 0018.32 1.68 4.889 4.889 0 0016.55.527C15.915.281 15.188.11 14.126.062 13.055.012 12.715 0 10 0z" />
          <path d="M10 4.863A5.138 5.138 0 004.863 10a5.138 5.138 0 0010.273 0c0-2.836-2.3-5.137-5.136-5.137zm0 8.469a3.333 3.333 0 11.001-6.665A3.333 3.333 0 0110 13.332zM16.54 4.66a1.2 1.2 0 11-2.4 0 1.2 1.2 0 012.4 0z" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1316_30807">
          <path fill="#fff" d="M0 0H20V20H0z" />
        </clipPath>
        <clipPath id="clip1_1316_30807">
          <path fill="#fff" d="M0 0H20V20H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
